import styled, { css } from 'styled-components';
import { ImageWithLazyAttributes } from "../utils";
export var PictureContainer = styled.picture.withConfig({
  componentId: "sc-1ip04c-0"
})(["", ""], function (_ref) {
  var width = _ref.width,
    height = _ref.height;
  return width && height && css(["display:inline-block;position:relative;width:100%;height:100%;max-width:", "px;max-height:", "px;overflow:hidden;padding-bottom:", "%;"], width, height, height / width * 100);
});
export var Image = styled(ImageWithLazyAttributes).withConfig({
  componentId: "sc-1ip04c-1"
})(["", ""], function (_ref2) {
  var width = _ref2.width,
    height = _ref2.height;
  return width && height && css(["position:absolute;top:0;left:0;height:100%;width:100%;"]);
});